import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import authApi from '../../api/authApi';
import { useToast } from '../../contexts/ToastContext';
import { useAuth } from '../../contexts/AuthContext';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [generalError, setGeneralError] = useState(null);
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { login: authLogin } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});
    setGeneralError(null);

    try {
      const response = await authApi.login(formData);
      if (response.success) {
        addToast('Login successful!', 'success');
        authLogin(response.data.access_token, response.data.user);
        navigate('/dashboard');
      } else {
        const errorMessage = response.message || 'Login failed. Please try again.';
        setGeneralError(errorMessage);
        addToast(errorMessage, 'error');
      }
    } catch (err) {
      console.error('Login error caught:', err);
      let errorMessage = 'An unexpected error occurred. Please try again.';

      if (err.response) {
        if (err.response.status === 422) {
          setValidationErrors(err.response.data.errors || {});
          errorMessage = err.response.data.message || 'Validation failed. Please check your input.';
        } else if (err.response.status === 401) {
          errorMessage = err.response.data.message || 'Invalid credentials.';
        } else {
          errorMessage = err.response.data.message || err.message || errorMessage;
        }
      } else {
        errorMessage = err.message || errorMessage;
      }
      
      setGeneralError(errorMessage);
      addToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-text-white mb-6">Admin Login</h2>
        {generalError && (
          <div className="bg-red-600 text-white p-3 rounded mb-4 text-center">
            {generalError}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <TextInput
              label="Email Address"
              id="email"
              name="email"
              type="email"
              placeholder={"Email Address"}
              value={formData.email}
              onChange={handleChange}
              error={validationErrors.email?.[0]}
              required
            />
          </div>
          <div className="mb-6">
            <TextInput
              label="Password"
              id="password"
              name="password"
              type="password"
              placeholder={"Password"}
              value={formData.password}
              onChange={handleChange}
              error={validationErrors.password?.[0]}
              required
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-accent-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            loading={loading}
          >
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;